<template>
    <div class="indicator-container">
      <ListHeader :title="data.name || '三级维度指标'">
            <template slot="right">
              <ActionButton :on-click="handleActionClick" />
            </template>
        </ListHeader>
        <div class="indicator-content">
            <div class="score-box">

              <Score :score="data.score || 0" :maxScore="data.maxScore || 0" />
            </div>
        </div>
    </div>
</template>
<script>
import ListHeader from '@/components/ListHeader.vue';
import Score from './Score.vue';
import ActionButton from './ActionButton.vue';
export default {
    name: 'ReportStyle1',
    components: {
        ListHeader,
        Score,
        ActionButton,
    },
    props: {
        data: {
            type: Object,
            default: null
        },
      onClick: {
        type: Function,
        default: () => { }
      }
    },
    data() {
      return {}
    },
    methods: {
      handleActionClick(type) {
        if (this.onClick) {
          this.onClick(type, this.data);
        } else {
          console.log(`在ReportStyle4中点击了${type}按钮`);
        }
      },
    }
}
</script>
<style lang="less" scoped>
@import '@/assets/css/common-indicator.less';
.indicator-container {
    .indicator-content {}
}
</style>
